import React, { Component } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { setViewstate } from '../actions/actionCreators';
import { size, color } from '../styles/helpers/variables';
import AccordionItemWithText from './AccordionItemWithText';
import { hideOnPrint } from "../styles/helpers/mixins";

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null
    };
    this.theme = {
      arrow: 'url(/images/icons/arrow.svg)',
      border: `solid 1px${color.grey}`,
      borderBottomColor: color.grey,
      fg: color.black
    };
    if (props.darkTheme) {
      this.theme.arrow = 'url(/images/icons/arrow-white.svg)';
      this.theme.border = 'solid 1px #333';
      this.theme.borderBottomColor = '#333';
      this.theme.fg = color.white;
    }
    this.setActive = this.setActive.bind(this);
  }

  setActive(index) {
    // set viewstate.brokeDesign to update StickyButton on ProductPage when an Accordion is opened
    this.props.setViewstate('brokeDesign', new Date().getTime());
    this.setState({
      activeIndex: this.state.activeIndex === index ? null : index
    });

    this.props.clickOnAccordionCallback();
  }

  render() {
    // Return this if there are multiple Accordion items
    if (Number.isInteger(this.props.children.length)) {
      return (
        <ThemeProvider theme={this.theme}>
          <AccordionContainer
            bm={this.props.bm}
            noMargin={this.props.noMargin}
            bottomBorder={this.props.children[this.props.children.length - 1].type === AccordionItemWithText}
            darkTheme={this.props.darkTheme}
          >
            {this.props.children.map((item, index) =>
              React.cloneElement(item, {
                key: index,
                index,
                setActive: this.setActive,
                isActive: this.state.activeIndex === index,
                isFirstItem: index === 0 || this.state.activeIndex === index - 1,
                darkTheme: this.props.darkTheme
              })
            )}
          </AccordionContainer>
        </ThemeProvider>
      );
    }

    // Return this if there is only a single Accordion item
    return (
      <ThemeProvider theme={this.theme}>
        <AccordionContainer
          bm={this.props.bm}
          noMargin={this.props.noMargin}
          bottomBorder={this.props.children.type === AccordionItemWithText}
          darkTheme={this.props.darkTheme}
        >
          {React.cloneElement(this.props.children, {
            index: 0,
            setActive: this.setActive,
            isActive: this.state.activeIndex === 0,
            isFirstItem: true
          })}
        </AccordionContainer>
      </ThemeProvider>
    );
  }
}

const AccordionContainer = styled.div`
  width: 100%;
  margin: 30px 0 0;
  border-bottom: solid 1px ${props => (props.bottomBorder ? props.theme.borderBottomColor : 'none')};
  ${props =>
    props.bm &&
    css`
      margin-bottom: ${props.bm};
    `};

  @media screen and (min-width: ${size.large}px) {
    margin: 34px 0 0;
  }
  
  ${props => props.noMargin && css`
      margin: 0 !important;
  `};
  
  ${hideOnPrint};
`;

Accordion.defaultProps = {
  bm: null,
  noMargin: null,
  darkTheme: false,
  clickOnAccordionCallback: () => {}
};

Accordion.propTypes = {
  bm: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  noMargin: PropTypes.bool,
  darkTheme: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  setViewstate: PropTypes.func.isRequired,
  clickOnAccordionCallback: PropTypes.func
};

export default connect(
  Accordion,
  { setViewstate }
);



// WEBPACK FOOTER //
// ./src/components/Accordion.js